export default __webpack_public_path__ + "static/image11-4e13e90bdfaf2d9fc9edf46a75539181.gif";